import { _baseGetFetch, _basePostFetch, _baseDeleteFetch, ApiEnum } from './baseFetch'

const reportsUploadsLimit = 10

export const getReports = (queryParams) => {
  return _baseGetFetch(`/report-problem`, queryParams)
}

export const getReportsCsv = async (queryParams) => {
  return _baseGetFetch(`/report-problem/download`, queryParams)
}

export const getReportsBySn = (sn, queryParams) => {
  return _baseGetFetch(`/products/${sn}/report-problem`, queryParams)
}

export const postReport = (queryParams) => {
  return _basePostFetch(`/report-problem `, queryParams)
}

export const getUsersEmail = () => {
  return _baseGetFetch(`/report-problem/notifications/users`)
}

export const deleteReport = (id) => {
  return _baseDeleteFetch(`/report-problem/${id}`)
}

// -----------------------------------------------------------
// COLTENE REPORTS API
// -----------------------------------------------------------

// ------------------------REGISTERED DEVICES------------------------
export const getRegisteredDevicesChartData = (bodyParams) => {
  return _baseGetFetch(`/reports/devices/registered/statistics`, bodyParams, ApiEnum.admin)
}

export const getRegisteredDevicesTableData = async (queryParams) => {
  return _baseGetFetch(`/reports/devices/registered`, { ...queryParams, maxResults: reportsUploadsLimit }, ApiEnum.admin)
}

export const getSoldDevicesCountries = async () => {
  return _baseGetFetch(`/reports/devices/countries`, {}, ApiEnum.admin)
}

export const getRegisteredDevicesCountries = async () => {
  return _baseGetFetch(`/reports/devices/registered/countries`, {}, ApiEnum.admin)
}

export const getConnectedDevicesCountries = async () => {
  return _baseGetFetch(`/reports/devices/connections/countries`, {}, ApiEnum.admin)
}

export const refreshRegisteredDevices = async () => {
  return _baseGetFetch(`/reports/devices/registered/refresh`, {}, ApiEnum.admin)
}

export const downloadRegisteredDevices = async (bodyParams) => {
  return _baseGetFetch(`/reports/devices/registered/download`, bodyParams, ApiEnum.admin)
}

// ------------------------GEOGRAPHICAL CONNECTION REPORTS------------------------
// export const getGeographicalConnectionChartData = (bodyParams) => {
//   return _baseGetFetch(`/reports/devices/connections/geographical/chart`, bodyParams, ApiEnum.admin)
// }

// export const getGeographicalConnectionTableData = async (queryParams) => {
//   return _baseGetFetch(`/reports/devices/connections/geographical`, { ...queryParams }, ApiEnum.admin)
// }

export const getGeographicalConnectionSummaryData = (queryParams) => {
  return _baseGetFetch(`/reports/devices/connections/geographical/statistics`, { ...queryParams }, ApiEnum.admin)
}

export const downloadGeographicalConnectionReports = async (bodyParams) => {
  return _baseGetFetch(`/reports/devices/connections/geographical/download`, bodyParams, ApiEnum.admin)
}

// ------------------------SOLD UNITS CONNECTION REPORTS------------------------
export const getSoldUnitsConnectionData = async (queryParams) => {
  return _baseGetFetch(`/reports/devices/connections/sold`, { ...queryParams }, ApiEnum.admin)
}

export const downloadRawSoldUnitsConnectionReports = async (bodyParams) => {
  return _baseGetFetch(`/reports/devices/connections/sold/download`, bodyParams, ApiEnum.admin)
}

export const downloadStatisticSoldUnitsConnectionReports = async (bodyParams) => {
  return _baseGetFetch(`/reports/devices/connections/sold/statistics/download`, bodyParams, ApiEnum.admin)
}

// ------------------------REGISTERED USERS------------------------
export const getRegisteredUsersChartData = (queryParams) => {
  return _baseGetFetch(`/reports/users/registered/statistics`, queryParams, ApiEnum.admin)
}

export const getRegisteredUsersTableData = (queryParams) => {
  return _baseGetFetch(`/reports/users/registered`, queryParams, ApiEnum.admin)
}

export const getRegisteredUsersCountries = async () => {
  return _baseGetFetch(`/reports/users/countries`, {}, ApiEnum.admin)
}

export const downloadRegisteredUsers = async (bodyParams) => {
  return _baseGetFetch(`/reports/users/registered/download`, bodyParams, ApiEnum.admin)
}

// ------------------------SOFTWARE DOWNLOADS REPORTS------------------------
export const getFirmwareDownloadStatisticsData = (queryParams) => {
  return _baseGetFetch(`/reports/firmware/statistics`, queryParams, ApiEnum.admin)
}

// export const getFirmwareDownloadTableData = (queryParams) => {
//   return _baseGetFetch(`/reports/firmware`, { ...queryParams, maxResults: reportsUploadsLimit }, ApiEnum.admin)
// }

export const getFirmwareDownloadCountries = async () => {
  return _baseGetFetch(`/reports/firmware/countries`, {}, ApiEnum.admin)
}

export const downloadFirmwareDownload = async (bodyParams) => {
  return _baseGetFetch(`/reports/firmware/download`, bodyParams, ApiEnum.admin)
}

// ------------------------ REMOTE ACCESS CONNECTION REPORTS ------------------------

export const getRemoteAccessConnectionRawData = (queryParams) => {
  return _baseGetFetch(`/reports/remote-access`, { ...queryParams }, ApiEnum.admin)
}

export const getRemoteAccessConnectionStatisticsData = (queryParams) => {
  return _baseGetFetch(`/reports/remote-access/statistics`, { ...queryParams }, ApiEnum.admin)
}

export const downloadRemoteAccessConnectionReports = async (bodyParams) => {
  return _baseGetFetch(`/reports/remote-access/download`, bodyParams, ApiEnum.admin)
}

// ------------------------ SOFTWARE VERSION REPORTS ------------------------

export const getSoftwareVersionRawData = (queryParams) => {
  return _baseGetFetch(`/reports/devices/firmware/versions`, { ...queryParams }, ApiEnum.admin)
}

export const getSoftwareVersionStatisticData = (queryParams) => {
  return _baseGetFetch(`/reports/devices/firmware/versions/statistics`, { ...queryParams }, ApiEnum.admin)
}

export const downloadSoftwareVersionReports = async (bodyParams) => {
  return _baseGetFetch(`/reports/devices/firmware/versions/download`, bodyParams, ApiEnum.admin)
}

export const getSoftwareVersionReportFilterOptions = async (bodyParams) => {
  return _baseGetFetch(`/reports/devices/firmware/versions/filters-options`, bodyParams, ApiEnum.admin)
}

